<template>
  <v-container>
    <div
      class="d-sm-flex d-xs-block justify-space-between align-center text-center"
    >
      <h1 class="primary--text">{{ title }}</h1>
    </div>
    <v-card class="mx-auto rounded-lg mt-5" elevation="0" outlined>
      <v-card-text class="secondary-font pa-3">
        <v-container class="mt-3">
          <v-form ref="dynamicForm">
            <v-row>
              <template v-for="component in processedComponents">
                <v-col
                  cols="12"
                  v-bind:key="component.uuid + 1"
                  class="pb-0 pt-2"
                >
                  <div
                    v-if="['LABEL'].includes(component.type)"
                    v-html="component.content"
                    class="mt-3 pt-3 mb-0 pb-0"
                  />
                  <p
                    class="caption mb-0 primary--text font-weight-medium"
                    v-if="
                      inputComponents.includes(component.type) &&
                      component.label
                    "
                  >
                    {{ component.label }}
                  </p>
                  <v-text-field
                    outlined
                    dense
                    hide-details="auto"
                    v-if="component.type == 'TEXTFIELD'"
                    :rules="getValidationRules(component)"
                    v-model="formData[component.entity][component.crm_field]"
                    class="pb-2"
                  ></v-text-field>
                  <v-textarea
                    outlined
                    dense
                    hide-details="auto"
                    v-if="component.type == 'TEXTAREA'"
                    :rules="getValidationRules(component)"
                    v-model="formData[component.entity][component.crm_field]"
                    class="pb-2"
                    rows="3"
                  ></v-textarea>
                  <v-select
                    :items="component.options"
                    :clearable="!component.required"
                    outlined
                    dense
                    hide-details="auto"
                    v-if="component.type == 'DROPDOWN'"
                    :rules="getValidationRules(component)"
                    v-model="formData[component.entity][component.crm_field]"
                    class="pb-2"
                  ></v-select>
                  <v-select
                    :items="component.options"
                    :clearable="!component.required"
                    outlined
                    dense
                    hide-details="auto"
                    v-if="component.type == 'CRM_DROPDOWN'"
                    :rules="getValidationRules(component)"
                    v-model="formData[component.entity][component.crm_field]"
                    class="pb-2"
                  ></v-select>
                </v-col>
              </template>
              <v-col cols="12" class="d-flex justify-end">
                <v-btn
                  class="text-capitalize mr-3"
                  color="secondary"
                  outlined
                  :to="{ name: cancelLink }"
                  exact
                  v-if="cancelLink"
                >
                  cancel
                </v-btn>
                <v-btn
                  class="text-capitalize"
                  color="secondary"
                  @click="handleSave"
                  >Save</v-btn
                >
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import validations from "@/utilities/validations-utility";
import functionsUtilities from "@/utilities/functions-utility";
import configurationsService from "@/services/configurations-service";
export default {
  name: "DynamicForm",
  props: ["title", "form", "initialData", "handleSubmit", "cancelLink"],
  data() {
    return {
      validations,
      formData: { ...this.initialData },
      inputComponents: ["TEXTFIELD", "TEXTAREA", "DROPDOWN", "CRM_DROPDOWN"],
      processedComponents: [],
    };
  },
  watch: {
    initialData() {
      this.formData = { ...this.getDataModel() };
      Object.keys(this.formData).map((key) => {
        this.formData[key] = functionsUtilities.copyValues(
          this.initialData,
          this.formData[key]
        );
      });
      this.$refs.dynamicForm.resetValidation();
    },
    components() {
      this.processComponents();
    },
  },
  computed: {
    components() {
      return this.$store.state.common.configurations
        ? this.$store.state.common.configurations[this.form]
        : [];
    },
  },
  mounted() {
    this.processComponents();
  },
  methods: {
    processComponents() {
      this.processedComponents = this.components || [];
      this.processedComponents.forEach((component) => {
        if (component.type == "CRM_DROPDOWN") {
          configurationsService
            .fetchCrmData({
              options_entity: component.options_entity,
              options_conditions: component.options_conditions,
              options_text: component.options_text,
              options_value: component.options_value,
            })
            .then((response) => {
              component.options = response.data.map((option) => ({
                text: option[component.options_text],
                value: option[component.options_value],
              }));
            });
        }
      });
    },
    getValidationRules(component) {
      const rules = [];
      if (component.required) {
        rules.push(validations.required);
      }
      return rules;
    },
    handleSave() {
      if (this.$refs.dynamicForm.validate()) {
        this.handleSubmit(this.formData);
      }
    },
    getDataModel() {
      const inputComponents = this.components.filter((component) =>
        this.inputComponents.includes(component.type)
      );
      return inputComponents.reduce((group, component) => {
        const { entity } = component;
        group[entity] = group[entity] ?? {};
        group[entity][component.crm_field] = null;
        return group;
      }, {});
    },
  },
};
</script>
